import { useState } from 'react';
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from '@/components/ui/Popover.tsx';
import CalendarMonthPicker from '@/components/form/_primitives/date/CalendarMonthPicker.tsx';
import CalendarYearPicker from '@/components/form/_primitives/date/CalendarYearPicker.tsx';
import { POLISH_MONTHS } from '@/components/form/_primitives/date/dateInputUtils.ts';

export type RangeCaptionSide = 'left' | 'right';

type RangeMonthCaptionProps = {
  month: Date;
  side: RangeCaptionSide;
  onMonthPick: (side: RangeCaptionSide, monthIdx: number) => void;
  onYearPick: (side: RangeCaptionSide, year: number) => void;
};

const triggerClass =
  'pointer-events-auto rounded-sm px-2 py-1 text-sm font-medium text-neutral-700 hover:bg-neutral-100';

const RangeMonthCaption = ({
  month,
  side,
  onMonthPick,
  onYearPick,
}: RangeMonthCaptionProps) => {
  const [monthOpen, setMonthOpen] = useState(false);
  const [yearOpen, setYearOpen] = useState(false);
  const monthIdx = month.getMonth();
  const year = month.getFullYear();

  return (
    <div className="pointer-events-none relative z-10 flex items-center justify-center gap-1">
      <Popover open={monthOpen} onOpenChange={setMonthOpen}>
        <PopoverTrigger asChild>
          <button type="button" className={triggerClass}>
            {POLISH_MONTHS[monthIdx]}
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="center"
          sideOffset={6}
          className="w-[220px] p-1.5"
        >
          <CalendarMonthPicker
            currentMonth={monthIdx}
            onPick={(idx) => {
              setMonthOpen(false);
              onMonthPick(side, idx);
            }}
          />
        </PopoverContent>
      </Popover>
      <Popover open={yearOpen} onOpenChange={setYearOpen}>
        <PopoverTrigger asChild>
          <button type="button" className={triggerClass}>
            {year}
          </button>
        </PopoverTrigger>
        <PopoverContent
          align="center"
          sideOffset={6}
          className="w-[200px] p-1.5"
        >
          <CalendarYearPicker
            currentYear={year}
            onPick={(y) => {
              setYearOpen(false);
              onYearPick(side, y);
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};

export default RangeMonthCaption;
